import { ProfileLiteView } from "admin/src/server/mappers/profile/profile";
import { FunctionFactory } from "survey-core";

export const registerProfileViewNameExpression = () => {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const profileViewNameExpression = function (this: any, params: any) {
    const stringifyProfileView = params[0];
    const profileView = JSON.parse(stringifyProfileView) as ProfileLiteView;

    return profileView
      ? `${profileView?.societyUser?.firstName} ${profileView?.societyUser?.lastName}`
      : "";
  };

  //Register the custom function
  FunctionFactory.Instance.register(
    "get_profile_view_name",
    profileViewNameExpression,
  );
};
